import { createStyles } from "@mantine/core"

export const useStyles = createStyles((theme) => ({
    container: {
        display: "grid",
        padding: `${theme.spacing.md} 0`,
        alignSelf: "stretch",
        flexWrap: "wrap",

        gap: theme.spacing.md,

        [theme.fn.largerThan("md")]: {
            gridTemplateColumns: "1fr 1fr 1fr 1fr",
        },
        [theme.fn.smallerThan("md")]: {
            gridTemplateColumns: "1fr 1fr 1fr",
        },
        [theme.fn.smallerThan("sm")]: {
            gridTemplateColumns: "1fr 1fr",
        },
    },
}))
